/* eslint-disable @typescript-eslint/no-explicit-any */

import diff from "microdiff"
import { NextRouter } from "next/router"
import { match } from "ts-pattern"
import { extractNormalQueryParams, NormalQueryParam } from "./routing"
import { Command, Add, Update, Remove } from "./diff-url-query-params"

const orderedNormalQueryParams: Record<NormalQueryParam, number> = {
    guests: 10,
    airfare: 20,
    gateway: 21,
    vs: 23,
    suite: 30,
    fare: 40,
    modal: 50,
    "suite-number": 60,
    checkout: 70,
}

type NextRouterQuery = NextRouter["query"]

export const diffUrlQueryParamsV4 = (
    prevQuery: NextRouterQuery | undefined,
    currentQuery: NextRouterQuery,
): Command[] => {
    const previous = extractNormalQueryParams(queryOrEmpty(prevQuery))
    const current = extractNormalQueryParams(currentQuery)

    const diffs = diff(previous, current)
        .map(toCommand)
        .map((d) => ({ ...d, index: orderedNormalQueryParams[d.key] }))
        .sort((a, b) => (a.index < b.index ? -1 : 1))

    return diffs.some((d) => d.type === "remove") ? diffs.reverse() : diffs
}

const queryOrEmpty = (query: NextRouterQuery | undefined): NextRouterQuery => query || {}

type Difference = ReturnType<typeof diff>[0]

const toCommand = (x: Difference): Command =>
    match(x)
        .with({ type: "CREATE" }, ({ path, value }): Add => ({ type: "add", key: toQueryParamKey(path), value }))
        .with(
            { type: "CHANGE" },
            ({ path, value, oldValue }): Update => ({ type: "update", key: toQueryParamKey(path), value, oldValue }),
        )
        .with(
            { type: "REMOVE" },
            ({ path, oldValue }): Remove => ({ type: "remove", key: toQueryParamKey(path), value: oldValue }),
        )
        .exhaustive()

// NOTE: query string is a list of key+value. We cannot find nested paths since its structure is flat
const toQueryParamKey = (path: (string | number)[]): NormalQueryParam => {
    if (!path.length) throw new Error("query param key from diff is empty")
    return path[0].toString() as NormalQueryParam
}
